import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteUserList = {
  deleteUserList: { data: null, loading: false, error: null },
};

export const deleteUserList = createAsyncThunk('user/deleteUserList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/users/active`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerDeleteUserList = {
  [deleteUserList.pending]: (state) => {
    state.deleteUserList.loading = true;
    state.deleteUserList.error = null;
  },
  [deleteUserList.fulfilled]: (state, action) => {
    state.deleteUserList.loading = false;
    state.deleteUserList.data = true;
    state.deleteUserList.error = null;
  },
  [deleteUserList.rejected]: (state, action) => {
    state.deleteUserList.loading = false;
    state.deleteUserList.error = action.payload;
  },
};
